export default __webpack_public_path__ + "static/11-peace-label-cb766a34c4158bf621d9fa7eaaba730b.svg";